/* auto-address.js - init Google Places autocomplete for Delivery Info */
let autocomplete;
let autocompleteInitialized = false;
let initRetryTimer = null;

function initAutocomplete() {
  if (autocompleteInitialized) return;

  const addressInput = document.getElementById('address');
  if (!addressInput) {
    console.warn('Address input not found on page.');
    return;
  }

  if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
    if (!initRetryTimer) {
      console.log('Google Maps API not ready yet - will retry initAutocomplete()');
      initRetryTimer = setTimeout(() => {
        initRetryTimer = null;
        initAutocomplete();
      }, 300);
    }
    return;
  }

  try {
    autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ['address'],
      componentRestrictions: { country: 'gb' },
      fields: ['address_components', 'formatted_address']
    });

    autocomplete.addListener('place_changed', fillInAddress);
    autocompleteInitialized = true;
    console.log('Google Autocomplete initialized');
  } catch (err) {
    console.error('Error initializing Google Autocomplete:', err);
  }
}

function fillInAddress() {
  if (!autocomplete) return;
  const place = autocomplete.getPlace();
  if (!place || !place.address_components) return;

  ['address', 'city', 'postcode'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  place.address_components.forEach((component) => {
    const types = component.types || [];

    if (types.includes('postal_code')) {
      const el = document.getElementById('postcode');
      if (el) el.value = component.long_name;
    }

    if (types.includes('postal_town') || types.includes('locality')) {
      const el = document.getElementById('city');
      if (el) el.value = component.long_name;
    }

    if (types.includes('route')) {
      const streetEl = document.getElementById('address');
      if (streetEl) streetEl.value = component.long_name + ' ' + (streetEl.value || '');
    }

    if (types.includes('street_number')) {
      const streetEl = document.getElementById('address');
      if (streetEl) streetEl.value = component.long_name + ' ' + (streetEl.value || '');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const addressInput = document.getElementById('address');
  if (!addressInput) {
    console.warn('Address input not found on page.');
    return;
  }

  addressInput.addEventListener('focus', initAutocomplete);
  addressInput.addEventListener('input', initAutocomplete);
  initAutocomplete();
});
